import React from 'react'
import * as styles from './styles.module.scss'
import translate from '../../../../../helpers/Translate'
import { SoundRating } from '../../../../../commonElements/vibrations/SoundRatind'
import { PowerRating } from '../../../../../commonElements/vibrations/PowerRating'
import question from '../../../../../images/icons/question-icon.svg'

export const LoopItemVibrations = ({
    id,
    sound,
    product,
    isSingleProduct,
    vibrationStrength,
    vibrationsProgress,
    isRoundup = false
}) => {
    
    let label

    let sd

    let pwr

    let vbr

    switch ( true ) {
        case sound <= 20:
            sd = translate('silent')
            break;
        case sound > 20 && sound <= 40:
            sd = translate('quiet')
            break;
        case sound > 40 && sound <= 60:
            sd = translate('fairly quiet')
            break;
        case sound > 60 && sound <= 80:
            sd = translate('noisy')
            break;
        case sound > 80:
            sd = translate('very loud')
            break;
        default:
            break;
    }

    switch ( true ) {
        case vibrationStrength <= 20:
            pwr = translate('weak')
            break;
        case vibrationStrength > 20 && vibrationStrength <= 40:
            pwr = translate('gently')
            break;
        case vibrationStrength > 40 && vibrationStrength <= 60:
            pwr = translate('quite powerful')
            break;
        case vibrationStrength > 60 && vibrationStrength <= 80:
            pwr = translate('very powerful')
            break;
        case vibrationStrength > 80:
            pwr = translate('extremely powerful')
            break;
        default:
            break;
    }

    switch ( true ) {
        case vibrationsProgress <= 20:
            vbr = translate('very buzzy')
            break;
        case vibrationsProgress > 20 && vibrationsProgress <= 40:
            vbr = translate('somewhat buzzy')
            break;
        case vibrationsProgress > 40 && vibrationsProgress <= 60:
            vbr = translate('neither really buzzy nor rumbly')
            break;
        case vibrationsProgress > 60 && vibrationsProgress <= 80:
            vbr = translate('somewhat rumbly')
            break;
        case vibrationsProgress > 80:
            vbr = translate('very rumbly')
            break;
        default:
            break;
    }
    
    label = `${translate(`The vibrations of the ${product} are`, product)} ${sd}, ${pwr}, ${translate('and')} ${vbr}` 

    return(
        <div className={`${styles.vibrations} ${isSingleProduct ? styles.single__product : ''} ${isRoundup ? styles.roundup : ''}`}>
            {! isSingleProduct && 
            <div className={styles.row}>
                {isRoundup ? <p className={styles.section__title}><strong>{translate('Vibrations')}</strong></p>
                : <p className={styles.section__title}><strong>{translate('Vibrations')}:</strong></p> }
            </div>}
            {isSingleProduct &&
            <div className={styles.row}>
                <p className={styles.section__res}>{label}</p>
            </div>
            }
            <div className={styles.row} style={{ marginTop : isRoundup ? '' : '-9px' }}>

                <div className={styles.rating}>
                    <SoundRating id={id} sound={sound} product={product} isRoundup={true}/>
                </div>

                <div className={styles.rating}>
                    <PowerRating id={id} vibrationStrength={vibrationStrength} product={product} isRoundup={true}/>
                </div>

                <div className={styles.recomendations__line}>
                    <div className={styles.recomendations__line__titles}>
                        <div className={styles.tooltip}>
                            <span className={styles.info__label}>
                                {translate('Buzzy')}
                                <img src={question} alt='Buzzy'/>
                            </span>
                            <div className={`${styles.hidden}`}>
                                <strong>{translate('What it is:')} </strong>{translate('Buzzy vibrators have a high frequency that stimulates the surface (like a high pitch).')}
                            </div>
                        </div>
                        <div className={styles.tooltip}>
                            <span className={styles.info__label}>
                                {translate('Rumbly')}
                                <img src={question} alt='Rumbly'/>
                            </span>
                            <div className={styles.hidden}>
                                <strong>{translate('What it is:')} </strong>{translate('Rumbly vibrators have low-frequency vibrations that stimulate deeper into the tissue (like the bass in music).')}
                            </div>
                        </div>
                    </div>
                    <div className={styles.recomendations__line__graph}>
                        <div style={{ width : vibrationsProgress >= 96 ? `calc(${vibrationsProgress}% - 20px)` : `${vibrationsProgress}% `}}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}